import React, { Component } from 'react';
import './Parallax.css';

export default class Parallax extends Component {
    render() {
        return (
            <div id={this.props.id} className="parallax" style={{backgroundImage: `url('/images/${this.props.image}')`}}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Parallax/Parallax.js